import { FC } from 'react';
import { IconPath, IconSVG, IconSVGComponentProps } from '../IconComponent';

export const GoalCollege: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        // Override viewBox & strokeWidth, since this is a solid icon
        <IconSVG viewBox="0 0 20 20" strokeWidth={0} {...props}>
            <IconPath
                fill="currentColor"
                d="M19 8.5 10 4 1 8.5l9 4.5 9-4.5Z"
                {...pathProps}
            />
            <IconPath
                fill="currentColor"
                d="M3.045 10.2v4.94h13.91V10.2L10 13.676l-6.955-3.478Z"
                {...pathProps}
            />
        </IconSVG>
    );
};
